/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_Protocol_Signers_RequiredInputs */

const cs_tasks_protocol_signers_required = /** @type {(inputs: Tasks_Protocol_Signers_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Před odesláním zadejte alespoň jeden e-mail signatáře.`)
};

const en_tasks_protocol_signers_required = /** @type {(inputs: Tasks_Protocol_Signers_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add at least one signer email before sending.`)
};

/**
* | output |
* | --- |
* | "Add at least one signer email before sending." |
*
* @param {Tasks_Protocol_Signers_RequiredInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const tasks_protocol_signers_required = /** @type {((inputs?: Tasks_Protocol_Signers_RequiredInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_Protocol_Signers_RequiredInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_protocol_signers_required(inputs)
	return cs_tasks_protocol_signers_required(inputs)
});